// extracted by mini-css-extract-plugin
module.exports = {"main":"ListFaType1_main__pi6QA"};